import React from "react";
import "./style.css";
import { useNavigate } from "react-router-dom";
import { ageAssessmentBasePath } from "../../../../helper";
import { assessmentIcons } from "../../../utils/assessmentIcons";
import { _onResetCaseRegistrationForm } from "../../../../redux/actions/age-assessment/caseRegistrationAction";
import { useDispatch } from "react-redux";

const AgeAssessmentShortCut = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onCreateNewProject = () => {
    dispatch(_onResetCaseRegistrationForm());

    navigate(`${ageAssessmentBasePath}/cases/new-case`);
  };
  return (
    <div
      className="age_assess_short_cut_container"
      onClick={onCreateNewProject}
    >
      <div
        className="age_assess_short_cut_body"
        style={{
          backgroundImage: `url(${assessmentIcons.homeBanner})`, // Ensure it's a valid URL
          backgroundSize: "cover", // Adjust as needed
          backgroundPosition: "center",
        }}
        // onClick={() => navigate(`${dentalBasePath}/projects`)}
      >
        <p className="age_assess_short_cut_heading">
          Initiate Precise Dental Age Assessment Today
        </p>
        <div
          className="age_assess_short_cut_button"
          onClick={() => navigate(`${ageAssessmentBasePath}/cases/new-case`)}
        >
          <span>Get Started</span>
        </div>
      </div>
    </div>
  );
};

export default AgeAssessmentShortCut;
